import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ComplianceDocumentDefinition } from '@texas/api/endpoints/metadata/complianceDocumentDefinitionsApi';
import { EntityDirectoryFileThumbnail } from '@texas/components/shared/entityDirectory/EntityDirectoryFileThumbnail';
import {
  entityWorkspaceStyles,
  getEntityWorkspaceListItemStyle,
} from '@texas/resources/theme/styles/entityWorkspace';
import {
  complianceDocumentKindLabel,
  complianceDocumentTypeLabel,
} from './translations';

export function ComplianceDocumentDefinitionOption({
  definition,
  assigned,
  selected,
  loading,
  showType = false,
  onSelect,
}: {
  definition: ComplianceDocumentDefinition;
  assigned: boolean;
  selected: boolean;
  loading: boolean;
  showType?: boolean;
  onSelect: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Box
      as="button"
      type="button"
      sx={getEntityWorkspaceListItemStyle(!assigned, selected)}
      aria-pressed={selected}
      disabled={assigned || loading}
      onClick={onSelect}
    >
      <Flex alignItems="center" gap={3} w="full">
        <EntityDirectoryFileThumbnail file={definition.logo} alt="" />
        <Box minW={0} flex={1} overflowWrap="anywhere">
          <Text sx={entityWorkspaceStyles.branchItemName}>
            {definition.name}
          </Text>
          <Text sx={entityWorkspaceStyles.branchItemNumber}>
            {definition.description}
          </Text>
          <Text sx={entityWorkspaceStyles.branchItemNumber}>
            {assigned
              ? t('article.management.alreadyAssigned')
              : [
                  complianceDocumentKindLabel(definition.kind, t),
                  ...(showType
                    ? [complianceDocumentTypeLabel(definition.type, t)]
                    : []),
                ].join(' · ')}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
